module.exports = __webpack_public_path__ + "static/image/thumbnail.png?e33f895c";